import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postReassignToOthers = createApi(`ReassignToOthersSlice`,"POST");

const ReassignToOthersSlice = createSlice({
  name: 'ReassignToOthersSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postReassignToOthers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postReassignToOthers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postReassignToOthers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ReassignToOthersSlice.reducer;